import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, vModelText as _vModelText, withDirectives as _withDirectives, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../assets/illustrations/illustration-create-profile.svg'


const _withScopeId = n => (_pushScopeId("data-v-35c67883"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: "add profile",
  class: "header"
}, null, -1))
const _hoisted_2 = { class: "content" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, "Create a New Profile", -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createTextVNode(" Choose a name from the "),
  /*#__PURE__*/_createElementVNode("a", { href: "https://docs.google.com/spreadsheets/d/1a0zIEVk6cKohRH32lQBO2B4k3mU_EBsF-QBWYjDUyu4/edit#gid=921484513" }, " thesarus "),
  /*#__PURE__*/_createTextVNode(" that you would like to use for this profile ")
], -1))
const _hoisted_5 = /*#__PURE__*/_createTextVNode(" Create Profile ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_base_modal = _resolveComponent("base-modal")!

  return (_openBlock(), _createBlock(_component_base_modal, {
    onConfirm: _ctx.confirm,
    onClose: _ctx.close,
    disabled: _ctx.profileInput === "",
    "main-button-color": "var(--color-confirm)"
  }, {
    header: _withCtx(() => [
      _hoisted_1
    ]),
    content: _withCtx(() => [
      _createElementVNode("section", _hoisted_2, [
        _hoisted_3,
        _hoisted_4,
        _withDirectives(_createElementVNode("input", {
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.profileInput) = $event)),
          placeholder: "Enter your profile name..."
        }, null, 512), [
          [_vModelText, _ctx.profileInput]
        ])
      ])
    ]),
    "button-content": _withCtx(() => [
      _hoisted_5
    ]),
    _: 1
  }, 8, ["onConfirm", "onClose", "disabled"]))
}